/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type LISTask = {
    readonly id?: number;
    readonly work_id?: number;
    type: LISTask.type;
    completed_at?: string | null;
    readonly updated_at?: string;
    started_at?: string | null;
    readonly created_at?: string;
}

export namespace LISTask {

    export enum type {
        ACCESSIONING = 'accessioning',
        GROSSING = 'grossing',
        SHIP = 'ship',
        PROCESSING = 'processing',
        EMBEDDING = 'embedding',
        CUTTING = 'cutting',
        SEND_OUT = 'send-out',
        RECEIVE = 'receive',
        IMPORT = 'import',
        STAINING = 'staining',
        COVERSLIPPING = 'coverslipping',
        FETCH_CASSETTE = 'fetch-cassette',
        FETCH_GLASS = 'fetch-glass',
        SCANNING = 'scanning',
    }


}
